module.exports = __webpack_public_path__ + "static/media/logo.e51c00f0.svg";